export interface IBizBrowserState {
  mode: BizBrowserMode
  modeChangedAt: Date
  durationSeconds?: number
  selectedDeviceKey: string
  scannerSettings: IScannerSettings
  isConnectedWithRfidDevice: boolean
  isDeviceScanning: boolean
  rfidPowerLevel: number
}

export interface IScannerSettings {
  vendor: string
  model: string
  address: string
}

export enum BizBrowserMode {
  IDLE = 'idle',
  CONNECTING_TO_SCANNER = 'connectingToScanner',
  SCANNING = 'rfidScanning',
  SHOWING_ALERT = 'showingAlert',
}
